import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useToast } from '../../../../../hooks'
import { productForm, productSchema } from '../../../../../validators/product-validator'
import { useLocalStorage } from '@/remote/local-storage'
import { useRemoteClientPost } from '@/configs/http-client'
import { formatCurrencyToNumber } from '@/view/utils/formatCurrency'
import { convertParamsToJson, useCashfitParams } from '@/view/hooks/use-params'
import { useSearchParams } from 'react-router-dom'


export const CreateProduct = () => {
  const { httpClientPost } = useRemoteClientPost()
  const { showToast } = useToast()
  const { getUnitId } = useLocalStorage()
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))

  const form = useForm<productForm>({
    resolver: zodResolver(productSchema),
    defaultValues: {
      valor: "0",
      valorComissao: "0,00",
      valorCusto: "0,00",
      valorDesconto: "0,00",
      quantidadeEstoque: 0,
      categoriaProduto: { id: 0 },
      unidade: { id: getUnitId() },
      tipoComissao: "VALOR_FIXO",
      descricao: '',
      imagem: 'https://no-image-example.aaaaaaaa',
      maxParcelas: 1,
      movimentarEstoque: true,
      nome: '',
      vendaOnline: false,
      centroCusto: { id: 0 }
    }
  })

  const onSubmit = async (data: productForm) => {

    const formattedData = {
      ...data,
      valor: formatCurrencyToNumber(data.valor),
      valorComissao: formatCurrencyToNumber(data.valorComissao),
      valorCusto: formatCurrencyToNumber(data.valorCusto),
      valorDesconto: formatCurrencyToNumber(data.valorDesconto),
    }
    try {
      await httpClientPost('/produto', formattedData)
      form.reset()
      showToast(
        'Produto criado com sucesso',
        'success'
      )
      setParams({ tabProductId: "" as any })
    } catch (error) {
      CatchMessageError(error,)
    }
  }

  return {
    onSubmit,
    form
  }
}
